var path = './top-nav/buttons/folderInfo_button.html';
var html = "<button class=\"wd-button-white\" \n    ng-class=\"enabled? '' : 'disabled-button'\"\n    ng-click=\"enabled? onClicked() : false\" translate>\n    TOP_NAV.PERMISSIONS\n</button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;